import { Container } from "@mantine/core";

export default function PageContainer({ children, ...style }) {
  return (
    <Container size="xl" {...style}>
      {children}
    </Container>
  );
}
